import { Location } from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DefaultComponent} from "../../shared/components/default.component";
import {IonModal, LoadingController, ToastController} from "@ionic/angular";
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {AuthenticationService} from "../../shared/_services/authentication.service";
import {SharedRoutesService} from "../../shared/_services/shared-routes.service";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})
export class SignupPage extends DefaultComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
  isLoading = false;
  registerForm: FormGroup;
  showErrors = false;


  constructor(
      private fb: FormBuilder,
      private loadingCtrl: LoadingController,
      private authenticationService: AuthenticationService,
      router: Router,
      activatedRoute: ActivatedRoute,
      sharedRoutesService: SharedRoutesService,
      toastController: ToastController
  ) {
    super(router, activatedRoute, sharedRoutesService,toastController);
  }

  ngOnInit() {
    this.registerForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(30)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10,14}$/)]],
      eircode: ['', [Validators.required, Validators.pattern(/^[A-Za-z0-9]{7}$/)]],
      cardUid: ['', [Validators.required, Validators.minLength(8)]],
      password: ['', [Validators.required, Validators.minLength(7)]],
      password_confirmation: ['', Validators.required],
    }, {
      validators: this.matchPasswords('password', 'password_confirmation')
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  matchPasswords(passwordKey: string, confirmPasswordKey: string) {
    return (group: AbstractControl): ValidationErrors | null => {
      const password = group.get(passwordKey)?.value;
      const confirmPassword = group.get(confirmPasswordKey)?.value;
      return password === confirmPassword ? null : { passwordsMismatch: true };
    };
  }



  onRegisterClick(): void {
    this.showErrors = true;

    if (this.registerForm.invalid) {
        console.log('Form is invalid:', this.registerForm.errors);
        return;
    }
    const queryParams = this.registerForm.value;
    console.log('Submitting:', queryParams);
    this.authenticationService.register(queryParams).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        data => {

          this.presentErrorToast("Registration successful, please check your email for verification link. Make sure to check your spam folder.");
          // Navigate after 2 seconds
          setTimeout(() => {
            this.router.navigate(['/authentication/login']);
          }, 2000);
        },
        error => {
          this.isLoading = false;
            this.showErrors = true;
            this.presentErrorToast(error.error.message);
        }
    );



    // proceed with your API call or success handling
  }


}
